<template>
  <base-stripe-table
    :headers="headers"
    :fetch-action="'listCoupons'"
    :items-getter="'getCoupons'"
    :pagination-getter="'getCouponPagination'"
  >
    <template v-slot:body="{ items }">
      <tbody>
        <tr
          v-for="item in items"
          :key="item.id"
          style="cursor:pointer;"
          @click="goto(item.id)"
        >
          <td>{{ item.name }}</td>
          <td>{{ item.id }}</td>
          <td>{{ terms(item) }}</td>
          <td class="text-right">
            {{
              item.max_redemptions
                ? `${item.times_redeemed} / ${item.max_redemptions}`
                : `${item.times_redeemed}`
            }}
          </td>
          <td v-date="item.redeem_by" />
        </tr>
      </tbody>
    </template>
  </base-stripe-table>
</template>
<script>
import BaseStripeTable from '@/components/Common/BaseStripeTable'
import { readableCouponTerms } from "../../services/stripe.service"

export default {
  components: {
    BaseStripeTable
  },
  data() {
    return {
      headers: [
        {
          text: 'Coupon Name',
          align: 'left',
          sortable: false,
        },
        {
          text: 'ID',
          sortable: false,
        },
        {
          text: 'Terms',
          sortable: false
        },
        {
          text: 'Redemptions',
          sortable: false
        },
        {
          text: 'Expires',
          sortable: false
        },
      ]
    }
  },
  methods: {
    terms: (coupon) => readableCouponTerms(coupon),
    goto(id) {
      this.$router.push({ name: 'coupon-detail', params: { id }})
    }
  },
}
</script>
